module.exports = __webpack_public_path__ + "static/media/splash1.48f9dbac.jpg";